import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "select" ]

  selectAll(event) {
    event.preventDefault()
    
    const options = Array.from(this.selectTarget.options)
      .map(option => option.value)
      .filter(value => value !== "")
    
    if (window.jQuery && window.jQuery(this.selectTarget).data('select2')) {
      window.jQuery(this.selectTarget).val(options).trigger('change')
    } else {
      Array.from(this.selectTarget.options).forEach(option => {
        if (option.value !== "") {
          option.selected = true
        }
      })
      this.selectTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }
}
